import { useEffect, useState } from 'react';
import K2Api from 'lib/ajax/K2Api';

const k2 = new K2Api();
function useK2Loader(endpoint, params) {
	const [response, setResponse] = useState();
	const [error, setError] = useState();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		let cancel = false;

		const performRequest = async () => {
			try {
				const response = await k2.get(endpoint, params);
				if (cancel) return;
				setResponse(response.data);
			} catch (error) {
				setError(error);
			} finally {
				setLoading(false)
			}
		}

		performRequest();

		return () => cancel = true;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [endpoint]);

	return [ loading, response, error ];
}

function useK2BulkLoader(loadRequests = []) {
	const [responses, setResponses] = useState();
	const [error, setError] = useState();
	const [loading, setLoading] = useState(true);

	const requestKey = JSON.stringify(loadRequests);

	useEffect(() => {
		let cancel = false;

		const performRequests = async () => {
			try {
				const results = await Promise.all(
					loadRequests.map(({ endpoint, params }) =>
						k2.get(endpoint, params)
							.then(res => res.data)
							.catch(err => ({ success: false, endpoint, params, error: err }))
					)
				);

				if (!cancel) setResponses(results);
			} catch (error) {
				if (!cancel) setError(error);
			} finally {
				if (!cancel) setLoading(false);
			}
		};

		if (loadRequests.length > 0) {
			performRequests();
		} else {
			setLoading(false);
			setResponses([]);
		}

		return () => { cancel = true; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestKey]);

	return [loading, responses, error];
}

export { useK2Loader, useK2BulkLoader };